import React from 'react'
import { AppStoreContext } from './AppStoreContext'
import { useAppStore } from './appStore'

interface AppStoreProviderProps {
  children: React.ReactNode
}

export const AppStoreProvider = ({ children }: AppStoreProviderProps) => {
  const store = useAppStore()

  return <AppStoreContext.Provider value={store}>{children}</AppStoreContext.Provider>
}
